import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { TooltipProvider } from '@radix-ui/react-tooltip'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import LaunchDarklyIdentify from 'app/LaunchDarklyIdentify'
import SourceBranchesReport from 'app/SourceBranchesReport'
import { injectStoreToFetchApi } from 'workflow/utils/Api'

import { injectStore, queryClient } from 'common/api'
import { ToastContainer } from 'common/components/toastNotification'
import { env } from 'common/config/env'
import { initLogger } from 'common/services/Logger'

import RouterComponent from './app/router/Router'
import { store } from './redux/store'

import './index.css'

injectStore(store)
injectStoreToFetchApi(store)
initLogger()
if (process.env.NODE_ENV === 'development' && env.enableMocks) {
  // dynamic import — require() is not valid in ESM (Vite)
  import('./mocks/dev/browser').then(({ worker }) => worker.start())
}

createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <Provider store={store}>
      <LaunchDarklyIdentify>
        <QueryClientProvider client={queryClient}>
          <TooltipProvider delayDuration={100}>
            <RouterComponent />
            <SourceBranchesReport />
            <ToastContainer />
            <ReactQueryDevtools initialIsOpen={false} />
          </TooltipProvider>
        </QueryClientProvider>
      </LaunchDarklyIdentify>
    </Provider>
  </React.StrictMode>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister()
